import { Box, Chip, LinearProgress, Typography } from '@material-ui/core'
import HistoryIcon from '@material-ui/icons/History'
import { useNavigate } from 'react-router-dom'

import { routeOverflowCauseSummary } from '../routeOverflowPresentation'
import ModalScan from './ModalScan'
import { CapacityBar, HistoryButton, OpenTreatmentButton, RouteCard, RouteGrid } from './styles'
import { useRoutesOver } from './useRoutesOver'

const RoutesOver = () => {
  const navigate = useNavigate()
  const { loading, routes, openModal, onClickRoute, onCloseModal, refresh } = useRoutesOver()

  return (
    <Box width="100%" maxWidth="1200px" margin="0 auto" padding="1rem">
      <LinearProgress style={{ width: '100%', opacity: loading ? 1 : 0 }} />
      <Box
        mt="2rem"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        style={{ gap: '1rem' }}
      >
        <Box>
          <Typography variant="h5" style={{ fontWeight: 600 }}>
            Rotas acima da capacidade
          </Typography>
          <Typography color="textSecondary">
            Abra uma rota para entender o estouro e reduzir os pedidos necessários.
          </Typography>
        </Box>
        <HistoryButton
          variant="outlined"
          startIcon={<HistoryIcon />}
          onClick={() => navigate('/operacao/conferencia/rotas-estouradas/historico')}
        >
          Ver histórico
        </HistoryButton>
      </Box>

      {!loading && routes.length === 0 && (
        <Box mt="4rem" textAlign="center">
          <Typography color="textSecondary">Nenhuma rota exige tratamento agora.</Typography>
        </Box>
      )}

      <RouteGrid>
        {routes.map(route => {
          const capacity = route.capacity_vehicle || 1
          const percentage = Math.min(100, (route.real_boxes_number / capacity) * 100)
          return (
            <RouteCard key={route.route}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" style={{ fontWeight: 700 }}>
                  Rota {route.route}
                </Typography>
                <Chip
                  size="small"
                  label="Tratamento pendente"
                  style={{
                    color: '#9C1C1C',
                    background: '#FDE2E2',
                  }}
                />
              </Box>
              <Typography variant="body2" color="textSecondary">
                Veículo {route.license_plate || 'não informado'}
              </Typography>
              <CapacityBar>
                <div style={{ width: `${percentage}%` }} />
              </CapacityBar>
              <Box display="flex" justifyContent="space-between" alignItems="baseline">
                <Typography style={{ fontWeight: 700 }}>
                  {route.real_boxes_number} caixas
                </Typography>
                <Typography style={{ color: '#C43C35', fontWeight: 600 }}>
                  +{route.excess_boxes} acima
                </Typography>
              </Box>
              <Typography variant="caption" color="textSecondary">
                Capacidade: {route.capacity_vehicle ?? 'não informada'} caixas
              </Typography>
              <Box mt="1rem">
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  {routeOverflowCauseSummary(route.route_above.cause_type)}
                </Typography>
              </Box>
              <OpenTreatmentButton variant="contained" onClick={() => onClickRoute(route)}>
                Abrir tratamento
              </OpenTreatmentButton>
            </RouteCard>
          )
        })}
      </RouteGrid>

      {openModal.open && openModal.data && (
        <ModalScan
          open={openModal.open}
          data={openModal.data}
          onClose={onCloseModal}
          refresh={refresh}
        />
      )}
    </Box>
  )
}

export default RoutesOver
